import { Alert, Box, Button, Chip, Menu, MenuItem, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from 'axios';
import { LocalShipping } from '@mui/icons-material';

// Konfigurasi chip H-min berdasarkan jarak ke tanggal pengiriman
const HMIN_CHIP = {
    "H-1": { label: "H-1", color: "warning" },
    "H-3": { label: "H-3", color: "secondary" },
    "H-7": { label: "H-7", color: "primary" },
    "H-0": { label: "Expired", color: "error" },
};

class NotifyFuDataPendingTele extends Component {
    state = {
        anchorEl: null,
        isMenuOpen: false,
        appNumber: Global.getAppProfile().waNumber
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, isMenuOpen: false });
    };

    getContactInfo = (waNumber) => {
        const params = { waNumber: waNumber };
        axios
            .post(Api.getContactInfo(), params, Api.getRequestHeaderJsonNew())
            .then((response) => {
                const responseData = response.data;
                if (responseData.success === true) {
                    const contact = this.props.generateItemConversation(responseData.data);
                    this.props.handleConversationSelected(contact);
                }
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message });
                console.error("There was an error!", error);
            });
    }

    renderHminChip = (hMinValue) => {
        const cfg = HMIN_CHIP[hMinValue];
        if (!cfg) return null;
        return (
            <Chip
                size="small"
                color={cfg.color}
                label={
                    <Box sx={{ fontSize: "10px", display: "flex", alignItems: "center", gap: "2px" }}>
                        <LocalShipping sx={{ width: "12px", height: "12px" }} /> {cfg.label}
                    </Box>
                }
                sx={{ height: "18px", cursor: "pointer" }}
            />
        );
    };

    render() {
        const count = this.props.listFuDataPendingTele?.length || 0;

        return (
            <Box sx={{ m: "8px" }}>
                <Alert
                    severity="warning"
                    variant="standard"
                    icon={<LocalShipping />}
                    action={
                        <Button
                            size="small"
                            variant="contained"
                            color="warning"
                            disableElevation
                            onClick={this.handleClick}
                            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", alignSelf: "center" }}
                        >
                            FU sekarang
                        </Button>
                    }
                    sx={{
                        borderRadius: "12px",
                        alignItems: "center",
                        border: "1px solid #ffe0a3",
                        "& .MuiAlert-message": { py: "4px" },
                    }}
                >
                    <Typography sx={{ fontSize: 13.5 }}>
                        <Box component="span" sx={{ fontWeight: 700 }}>{count}</Box> customer tele perlu di-follow up
                    </Typography>
                </Alert>

                <Menu
                    id="menu-fu-data-pending-tele"
                    anchorEl={this.state.anchorEl}
                    open={this.state.isMenuOpen}
                    onClose={this.handleClose}
                    MenuListProps={{ 'aria-labelledby': 'basic-button', sx: { py: "4px" } }}
                    slotProps={{ paper: { sx: { borderRadius: "12px", maxHeight: 380 } } }}
                >
                    {this.props.listFuDataPendingTele?.map((item, index) => (
                        <MenuItem
                            key={index}
                            disabled={this.state.appNumber !== item.to}
                            onClick={() => this.getContactInfo(item.from)}
                            sx={{ px: "8px", py: "4px" }}
                        >
                            <Box
                                sx={{
                                    width: 268,
                                    p: "8px 10px",
                                    borderRadius: "10px",
                                    border: "1px solid #ffe0a3",
                                    backgroundColor: "#fffdf7",
                                }}
                            >
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: 13, textTransform: "capitalize", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {item.fromName}
                                    </Typography>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#8a5a00", whiteSpace: "nowrap" }}>
                                        {item.aplikasi} {item.isCsCustomer ? "(CS)" : ""}
                                    </Typography>
                                </Box>

                                <Typography sx={{ fontSize: 11, color: "#667781", mt: "2px" }}>
                                    {Global.maskPhoneNumber(item.from)}
                                </Typography>

                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "6px", gap: 1 }}>
                                    <span className={Global.getLabelClasses(item.label)} style={{ fontSize: "10px" }}>{item.label}</span>
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "2px" }}>
                                        {this.renderHminChip(item.hMinValue)}
                                        <Typography sx={{ fontSize: 10, color: "#98a2b3", whiteSpace: "nowrap" }}>
                                            {Global.formatDateTimeToStrDateTime24(item.deliveryDate, true)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        );
    }
}

export default NotifyFuDataPendingTele;
